import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { multimediaEpaycoOrigin } from './utils/multimedia';

import * as serviceWorker from './serviceWorker';

if (multimediaEpaycoOrigin) {
  const root = document.documentElement;
  root.style.setProperty(
    '--multimedia-arrows-select',
    `url('${multimediaEpaycoOrigin}/dashboard/recaudo/proyecto/imagenes/arrowsSelect.png')`
  );
  root.style.setProperty(
    '--multimedia-triangle',
    `url('${multimediaEpaycoOrigin}/dashboard/login/img/Triangle.png')`
  );
}

ReactDOM.render(<App/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
